import { useState, useEffect, useMemo } from 'react';
import { 
    ChevronDownIcon, 
    // PencilSquareIcon, 
    TrashIcon   
} from '@heroicons/react/16/solid';
import Autocomplete from '@mui/material/Autocomplete';
import {
    TextField,
    // Typography,
    // useMediaQuery,Tooltip,
    // CircularProgress,
} from '@mui/material';
import axios from 'axios';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import {  
    DataGrid,
    gridClasses,
    // GridColDef,
    GridToolbarQuickFilter,
    // GridLogicOperator,
    // GridActionsCellItem,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    useGridSelector,
  } from '@mui/x-data-grid';
  import MuiPagination from '@mui/material/Pagination';
  import ReserveFundsActions from '../../components/dataTable/ReserveFundsActions';
  import { useUserContext } from '../../contexts/UserContext';


function formatDateTime() {
    const now = new Date();
  
    const year = now.getFullYear(); // Get the year
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0'); // Day of the month
  
    const hours = String(now.getHours()).padStart(2, '0'); // Hours
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Minutes
    const seconds = String(now.getSeconds()).padStart(2, '0'); // Seconds
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const transType = [
    {
        value: 1,
        label: 'IN',
    },
    {
        value: 2,
        label: 'OUT',
    },
];

function numberWithCommas (nStr) {
    nStr = nStr + '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
  };
const options = [{item:'เงินสำรองจ่าย'}, {item:'เบิกซื้อของ'}];

const apiurl = `${process.env.REACT_APP_API}`;

// ReceiptItem Component: For individual receipt items
// const ReceiptItem = ({ item, onUpdate, onRemove }) => {
//     return (
//       <div style={{ display: "flex", marginBottom: "10px" }}>
//         <input
//           type="text"
//           placeholder="Item Name"
//           value={item.name}
//           onChange={(e) => onUpdate({ ...item, name: e.target.value })}
//           style={{ marginRight: "10px" }}
//         />
//         <input
//           type="number"
//           placeholder="Quantity"
//           value={item.quantity}
//           onChange={(e) => onUpdate({ ...item, quantity: e.target.value })}
//           style={{ marginRight: "10px" }}
//         />
//         <input
//           type="number"
//           placeholder="Price"
//           value={item.price}
//           onChange={(e) => onUpdate({ ...item, price: e.target.value })}
//           style={{ marginRight: "10px" }}
//         />
//         <button onClick={onRemove}>Remove</button>
//       </div>
//     );
//   };

function ReserveFunds() {
    const user = useUserContext();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errMsg, setErrMsg] = useState({type:'', info:''});
    const [valuesf, setValuesf] = useState([]);
    const [category, setCategory] = useState(null);
    const [dataChenged, setDataChenged] = useState(false);
    const [id, setID] = useState(0);
    const [dfrom, setDfrom] = useState();
    const [dto, setDto] = useState();
    const [input, setInput] = useState({
        date: formatDateTime(),
        transType: 'IN',
        item:'เงินสำรองจ่าย',
        amount: 0,
        note:  '',
    });
    const [period, setPeriod] = useState('today');
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [rowId, setRowId] = useState(null)
    const [totalRow, settotalRow] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
      });

    const [rowCount ,setRowCount] = useState({
        rowCount: totalRow,
    })

    const columns  = useMemo(() => [
        { field: "id", 
          type: "number", 
          headerName: "ID", 
          headerAlign: 'center', 
          width: 60, 
        },
        {
          field: "date",
          headerName: "Date",
          sortable: false,
          filterable: false,
          headerAlign: 'center',
          width: 160,
          editable: false,
      
          // renderCell: (params) => {
          //   return <img src={`${process.env.REACT_APP_URL}/image/users/${params.row.Avatar} || '/user.png'`} alt="" />;
          // },
        },
        {
          field: "itemType",
          type: "string",
          headerName: "Type",
          width: 110,
          editable: false,
        //   flex:.5, 
        //   minWidth: 80,
        },
        // {
        //   field: "lastName",
        //   type: "string",
        //   headerName: "Last name",
        //   width: 150,
        // },
        {
          field: "item",
          type: "string",
          headerName: "Item",
          width: 200,
          editable: false,
          flex:1,
          minWidth: 150, 
        },
        {
          field: "amount",
          type: "number",
          headerName: "Amount",
          width: 125,
          headerAlign: 'center',
          editable: false,
        //   flex: 1,
        //   minWidth: 120,
        },
        {
          field: "note",
          type: "string",
          headerName: "Note",
          width: 200,
          editable: false,
          flex:1,
          minWidth: 200,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            type: 'actions',
            // getActions: (params) => [
            //     <GridActionsCellItem
            //       icon={<TrashIcon />}
            //       label="Delete"
            //       onClick={handleDeleteItem(params.id)}
            //     />,
                // <GridActionsCellItem
                //   icon={<SecurityIcon />}
                //   label="Toggle Admin"
                //   onClick={toggleAdmin(params.id)}
                //   showInMenu
                // />,
                // <GridActionsCellItem
                //   icon={<FileCopyIcon />}
                //   label="Duplicate User"
                //   onClick={duplicateUser(params.id)}
                //   showInMenu
                // />,
            //   ],
            renderCell: params => <ReserveFundsActions {...{params, rowId, setRowId, setValuesf}} />,
            headerAlign: 'center',
            width: 80,
            editable: false,
            // flex: 1,
        },
  
      ],[rowId]);

    const handleClickOpen = () => {
        setOpen(true);
      };
  
      const handleClose = () => {
        setOpen(false);
      };

    const handleSave = async () => {
        setErrMsg({
            type: 'onProcess',
            info: 'Saving...'
        });

        const data = { 
            mode: 'add',
            items: items,
          };
    
        try {
            const res = await axios({
                      method: 'post',
                      url: `${apiurl}/expense.php`,
                      headers: {
                          'Accept': 'application/json',
                          // 'Content-type': 'application/x-www-form-urlencoded',
                          // 'Content-type': 'application/json; charset=utf-8',
                          'Content-Type': 'multipart/form-data'
                      },
                      data: JSON.stringify(data) ,
                      // data: data,
                  });
    
                //   console.log(res);
                  if(res.data?.success) {
                    // console.log(res.data);
                    setDataChenged(false);
                    handleCancel();
                    await fetchReserveFunds('today');
    
                    setErrMsg({
                        type: 'success',
                        info: res.data.success,
                    })
                    return true;
                  } else {
                    setErrMsg({
                        type: 'err',
                        info: 'Saving Error'
                    });
                    return false;
                  }
    
          } catch (error) {
            console.error("Error fetching invoice:", error);
            // setresMessage("Error!!!");
            setErrMsg({
                type: 'err',
                info: error.message
            })
            return false;
          }
          
        
    }

    // const handleDeleteItem = async (id) => {
    //     // console.log(id);
    //     setErrMsg({
    //         type: 'onProcess',
    //         info: 'Deleting...'
    //     });
        
    //     try {
    //         const res = await axios.get(`${apiurl}/expense.php?mode=delete&id=${id}`);
    
    //               console.log(res);
    //               if(res.data?.success) {
    //                 // console.log(res.data);
    //                 setErrMsg({
    //                     type: 'success',
    //                     info: res.data.success,
    //                 })
    //                 setDataChenged(false);
    
    //                 return true;
    //               } else {
    //                 setErrMsg({
    //                     type: 'err',
    //                     info: 'Deleting Error'
    //                 });
    //                 return false;
    //               }
    
    //       } catch (error) {
    //         console.error("Error delete reserveFunds:", error);
    //         // setresMessage("Error!!!");
    //         setErrMsg({
    //             type: 'err',
    //             info: error.message
    //         })
    //         return false;
    //       }
          
        
    // }

    const fetchItem = async () => {
        // setErrMsg({
        //     type: 'onProcess',
        //     info: 'Deleting...'
        // });
    
        try {
            const res = await axios.get(`${apiurl}/expense.php?mode=getitems`);
    
                //   console.log(res);
                  if(res.data.message==="OK") {
                    setCategory(res.data.data);

                    return true;
                  } else {
                    setCategory(options);
                    // setErrMsg({
                    //     type: 'err',
                    //     info: 'Deleting Error'
                    // });
                    return false;
                  }
    
          } catch (error) {
            console.error("Error fetching items:", error);
            // setresMessage("Error!!!");
            setErrMsg({
                type: 'err',
                info: error.message
            })
            return false;
          }
          
        
    }

    const fetchReserveFunds = async (period) => {
        setLoading(true);
        setPeriod(period);
        // setReportType(period);
        // console.log(dfrom,dto,period);
        let qs = "";
        if(period==="range") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

    //    console.log(qs);
        try {
            const res = await axios.get(`${apiurl}/expense.php?mode=list&${qs}`, {
                params: {
                  itemsPerPage: paginationModel.pageSize,
                  page: paginationModel.page,
                },
              });
            // console.log(res);
            if(res.data.message==="OK") {
              setValuesf(res.data.data);
              settotalRow(res.data.rowTotal);
            //   settotalPages(res.data.totalPages);
              setLoading(false);
  
              setErrMsg({
                type: '',
                info: '',
            })

            } else {
                setErrMsg({
                    type: 'err',
                    info: 'No record found!!!',
                })
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        setLoading(false);
      };


      useEffect(() => {
        fetchReserveFunds(period);
      },[paginationModel])
    
      useEffect(() => {
        fetchItem();
      },[])
  
    // Function to add a new item
    // const addItem = () => {
    //   setItems([...items, { id: Date.now(), name: "", quantity: 1, price: 0 }]);
    // };
  
    // // Function to update an item
    // const updateItem = (updatedItem) => {
    //   setItems(items.map((item) => (item.id === updatedItem.id ? updatedItem : item)));
    // };
  
    // // Function to remove an item
    // const removeItem = (id) => {
    //   setItems(items.filter((item) => item.id !== id));
    // };
  
    // // Calculate total price
    // const calculateTotal = () => {
    //   const totalAmount = items.reduce(
    //     (sum, item) => sum + item.quantity * item.price,
    //     0
    //   );
    //   setTotal(totalAmount);
    // };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // console.log(input);
  };

  const handleAddItem = () => {
    setItems([...items, { 
        // date: formatDateTime(),
        date: input.date,
        transType: input.transType,
        item:input.item,
        amount: input.amount,
        note:  input.note,
    }]);
    setDataChenged(true);
    setInput({
        date: formatDateTime(),
        transType: input.transType,
        item:input.item,
        amount: 0,
        note:  '',
    })

  }

//   const handleEditItem = (id) => {
//     // console.log(id);
//     setID(id);
//     const edititem = items.filter((item) => item.date === id);
//     console.log(edititem);
//     setInput({
//         date:edititem.date,
//         transType: edititem.transType,
//         item: edititem.item,
//         amount: edititem.amount,
//         note: edititem.note,
//       });

//   }

//   const handleUpdateItem = () => {
//     setItems(items.map((item) => (item.date === input.date ? input : item)));
//     setID(0);
//   }

  const handleRemoveItem = (id) => {
    // console.log(id);
    setItems(items.filter((item) => item.date !== id));
  }

  const handleCancel = () => {
    setItems([]);
    setInput({
        date: formatDateTime(),
        transType: 'IN',
        item:'เงินสำรองจ่าย',
        amount: 0,
        note:  '',
    })
    
    setDataChenged(false);

  }
 
    function Pagination({ page, onPageChange, className }) {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
            />
        );
    }

    function CustomPagination(props) {
        return <GridPagination ActionsComponent={Pagination} {...props} />;
    }
//   console.log(category);
    // console.log(paginationModel.page,paginationModel.pageSize);      

  return (
    <div className="flex flex-col w-[calc(100vw)] sm:w-[calc(100vw-160px)] mx-auto h-[calc(100vh-120px)] overflow-y-auto">
        <h1>เงินสำรองจ่าย</h1>
        <div className="flex flex-col mx-auto mt-0 p-2 w-full justify-center items-center">
            <h2 className="text-base/7 text-gray-300">เพิ่มรายการ</h2>
            <div className="mt-0 grid grid-cols-1 md:grid-cols-2 md:gap-2 max-w-lg">
                <div className="col-span-1">
                    <label htmlFor="date" className="block text-sm/6 font-medium text-gray-300">
                        Date
                    </label>
                    <div className="mt-0 grid grid-cols-1">
                        <input
                            id="date"
                            name="date"
                            value={input.date}
                            // disabled
                            onChange={handleInput}
                            autoComplete="given-date"
                            type="datetime-local"
                            className="block sm:w-full rounded-md bg-slate-100 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                <div className="col-span-1">
                    <label htmlFor="transType" className="block text-sm/6 font-medium text-gray-300">
                        TransType
                    </label>
                    <div className="mt-0 grid grid-cols-1">
                        <select
                        id="transType"
                        name="transType"
                        value={input.transType}
                        onChange={handleInput}
                        autoComplete="transType"
                        className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        >
                        {transType.map((t,i) => (
                        <option key={i}>{t.label}</option>
                        ))}
                        </select>
                        <ChevronDownIcon
                        aria-hidden="true"
                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                        />
                    </div>
                </div>
                <div className="col-span-1">
                    <label htmlFor="item" className="block text-sm/6 font-medium text-gray-300">
                        Item
                    </label>
                    <div className="mt-0 grid grid-cols-1">
                    <Autocomplete
                        id="item"
                        name="item"
                        freeSolo
                        size="small"
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        value={input.item}
                        // onChange={handleFormChange('category')}
                        inputValue={input.item}
                        onInputChange={(event, newInputValue) => {
                        setInput({ ...input, item: newInputValue });
                        }}
                        options={category?.map((option) => option.item)}
                        // options={options}
                        renderInput={(params) => <TextField {...params}  />}
                    
                        className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    />
                    </div>
                </div>
                <div className="col-span-1">
                    <label htmlFor="amount" className="block text-sm/6 font-medium text-gray-300">
                        Amount
                    </label>
                    <div className="grid grid-cols-1 mt-0">
                        <input
                        id="amount"
                        name="amount"
                        value={input.amount}
                        onChange={handleInput}
                        onFocus={(e) => e.target.select()}
                        autoComplete="given-amount"
                        type="number"
                        className="block sm:w-full rounded-md bg-white p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                <div className="col-span-1">
                    <label htmlFor="note" className="block text-sm/6 font-medium text-gray-300">
                        Note
                    </label>
                    <div className="mt-0 grid grid-cols-1">
                        <input
                        id="note"
                        name="note"
                        value={input.note}
                        onChange={handleInput}
                        autoComplete="given-note"
                        type="text"
                        className="block sm:w-full rounded-md bg-white p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                <div className="flex items-end justify-center md:justify-end col-span-1 gap-2">
                    {/* <button 
                        type="button" 
                        disabled={id===0 ? true : false}
                        className="rounded-md bg-blue-800 disabled:bg-slate-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        onClick={handleUpdateItem}
                    >
                        Update Item
                    </button> */}

                    <button 
                        type="button" 
                        // disabled={id===0 ? false : true}
                        className="rounded-md bg-teal-800 disabled:bg-slate-500 px-3 py-2 mt-2 md:mt-0 text-sm text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        onClick={handleAddItem}
                    >
                        Add Item
                    </button>
                </div>
            </div>
            <div className="flex flex-col w-full max-w-2xl mt-6 p-1 justify-center">
                <table className="w-full table-auto">
                    {/* <caption className="caption-bottom text-right py-4 text-lg font-bold pr-2">
                        Total : {numberWithCommas(sumtotal(orders))}
                    </caption>  */}
                    <thead>
                        <tr className="border bg-slate-800">
                            <th className="border font-normal">Date</th>
                            <th className="border font-normal">Type</th>
                            <th className="border font-normal">Item</th>
                            <th className="border font-normal">Amount</th>
                            <th className="border font-normal">Note</th>
                            <th className="border font-normal">Action</th>
                            </tr>
                    </thead>
                    <tbody>
                        {items?.map((item,i) => (
                            <tr key={i} className="border odd:bg-blue-500">
                                <td className="text-center border">{item.date}</td>
                                <td className="text-center border">{item.transType}</td>
                                <td className="text-center border">{item.item}</td>
                                <td className="text-center border">{item.amount}</td>
                                <td className="text-center border">{item.note}</td>
                                <td className="text-center border">
                                    <div className="flex gap-2 justify-center">
                                        {/* <button
                                            onClick={() => handleEditItem(item.date)}
                                        >
                                           <PencilSquareIcon className="h-6 w-6 text-teal-700 hover:text-teal-400" /> 
                                        </button> */}
                                        <button
                                            onClick={() => handleRemoveItem(item.date)}
                                        >
                                           <TrashIcon className="h-6 w-6 text-slate-500 hover:text-red-300" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-6 flex w-full max-w-2xl items-center justify-between gap-x-6 border-t-2 px-20 py-2">
                <button 
                    type="button" 
                    disabled={!dataChenged}
                    className={dataChenged? "rounded-md bg-red-800  px-3 py-2 text-sm text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm"}
                    onClick={handleCancel}
                    >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={!dataChenged}
                    className={dataChenged? "rounded-md bg-indigo-600 px-3 py-2 text-sm text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" :"rounded-md bg-slate-800 px-3 py-2 text-sm"}
                    onClick={handleSave}
                >
                    Save
                </button>
                {/* </div> */}
            </div>
                {/* <MessInfo mess={errMsg} /> */}
            <p className={errMsg.type==='err'? "text-red-600" : "text-green-600"}>
                {errMsg.info}
            </p>
        </div>
        
        <div className="flex flex-col px-2 mt-2 max-w-4xl lg:mx-auto">
            <h1>Detail</h1>
            {user?.user?.isAdmin>0 && 
            <div className="flex flex-col md:flex-row p-2 gap-2 items-start justify-start md:justify-between">
                <div>
                    <button onClick={() => fetchReserveFunds('today')} className="hover:text-green-500"> ToDay </button> <span> / </span>
                    <button onClick={() => fetchReserveFunds('daily')} className="hover:text-green-500"> Daily </button> <span> / </span>
                    <button onClick={() => fetchReserveFunds('weekly')} className="hover:text-green-500"> Weekly </button> <span> / </span>
                    <button onClick={() => fetchReserveFunds('monthly')} className="hover:text-green-500"> Monthly </button>
                </div>
                <div  className="flex flex-row col-span-1 gap-2 items-end">
                    <div>
                        <label htmlFor="dfrom" className="block text-sm/6 font-medium text-gray-300">
                            From
                        </label>
                        <input
                            id="dfrom"
                            name="dfrom"
                            value={dfrom}
                            disabled={false}
                            onChange={(e) => setDfrom(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div>
                        <label htmlFor="dto" className="block text-sm/6 font-medium text-gray-300">
                            To
                        </label>
                        <input
                            id="dto"
                            name="dto"
                            value={dto}
                            disabled={false}
                            onChange={(e) => setDto(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div  className="flex items-end col-span-1 gap-2">
                        <button 
                            type="button" 
                            // disabled={id===0 ? false : true}
                            className="rounded-md bg-teal-800 disabled:bg-slate-500 p-1 mt-2 md:mt-0 text-sm text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => fetchReserveFunds('range')}
                        >
                            Get Item
                        </button>
                    </div>
                </div>
            </div>
            }
            {loading ? (
                <p>Loading...</p>
            ) : (
                valuesf && (
                <div >
                    <DataGrid 
                        checkboxSelection={false} 
                        rows={valuesf} 
                        rowCount={totalRow}
                        columns={columns} 
                        density='compact'
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                },
                            },
                        }}
                        // page={page}
                        // autoPageSize
                        // pageSize={pageSize}
                        // rowsPerPageOptions={[5,10,30,50,100]}
                        paginationMode="server"
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        onRowCountChange ={setRowCount}
                        pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
                        pagination
                        slots={{
                            pagination: CustomPagination,
                            toolbar:  GridToolbarQuickFilter,
                        }}
                        // onPageChange={(newPage) => setPage(newPage)}
                        // onPageChange={handlePageChange}
                        // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        // onPageSizeChange={handlePageSizeChange}
                        // filterMode="server"
                        // onFilterModelChange={onFilterChange}
                        // disableSelectionOnClick
                        getRowId={(row) => row.date}
                        // onCellEditCommit={(params) => setRowId(params.id)}
                        processRowUpdate={(updatedRow, originalRow) => {
                        // console.log(updatedRow);
                        // console.log(originalRow);
                        //   getObjectChanges(originalRow, updatedRow)
                        return updatedRow;
                        // setRowId(params.id)
                        }}
                        headerHeight={38}
                        // componentsProps={{
                        //   toolbar: {
                        //     showQuickFilter: true,
                        //     quickFilterProps: { debounceMs: 1000},
                        //   },
                        // }}
                        sx={{ 
                            // m:2,
                            [`& .${gridClasses.row}`]: {
                                bgcolor: '#f1e9e9',
                                // bgcolor: (theme) =>
                                // theme.palette.mode === 'light' ? grey[300] : grey[900],
                            },
                            [`& .${gridClasses.columnHeader}`] : {
                                bgcolor: '#0e0e7b',
                                color: '#ffffff',
                                // bgcolor: (theme) =>
                                //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                            },
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "skyblue"
                                // color: "red"
                            },
                                "& .MuiDataGrid-row.Mui-selected": {
                                    bgcolor: '#0e6496',
                                    color: '#ffffff',
                                    '&:hover': {
                                        bgcolor: '#1593c4',
                                    },
                                },
                                "& .MuiSvgIcon-root": {
                                    fill: "#9e9a9a",
                                },
                                "& .MuiInputBase-input.MuiInput-input": {
                                    color: "#9e9a9a",
                                },
                                "& .MuiTablePagination-root": {
                                    color: "#ffffff",
                                },
                                [`.${gridClasses.cell}.neg`]: {
                                    backgroundColor: '#b9d5ff91',
                                    color: '#ef0b0b',
                                },
                                [`.${gridClasses.cell}.pos`]: {
                                // backgroundColor: '#ff943975',
                                color: '#000000',
                                },

                            // [`& .${gridClasses.GridToolbarExport}`] : {
                            //   color: (theme) =>
                            //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                            // },

                        }}
                        getCellClassName={(params) => {
                                if (params.field === 'instock') {
                                    return params.value < 0 ? 'neg' : 'pos';;
                                }
                        }}
                        // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                        loading={loading}
                        // className="bg-gray-600 bg-gray-600"
                    />    
                </div>
            ))}
        </div>
    </div>
  )
}

export default ReserveFunds